import { createFileRoute } from '@tanstack/react-router'
import EmployeeAssets from '@/features/employee-assets'
import { ProtectedRoute } from '@/components/auth/protected-route'
import { Permissions } from '@/constants/roles-permissions'

export const Route = createFileRoute('/_authenticated/employee-assets')({
  component: EmployeeAssetsRoute,
})

function EmployeeAssetsRoute() {
  return (
    <ProtectedRoute requiredPermission={Permissions.EmployeeAssetView}>
      <EmployeeAssets />
    </ProtectedRoute>
  )
} 